import * as React from 'react'
import { FC, useMemo } from 'react'
import { BillToMatchDrawerProps } from './typings'
import { useActions } from './hooks'
import { Header, BillToMatchList, SearchSection } from './atoms'
import { SideDrawerForm, Pagination } from '@sales-center/components'
import {
  getLocationSearchTerm,
  useSearchBillTos,
} from '@user/store/entityLocations'

import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

export const BillToMatchDrawer: FC<BillToMatchDrawerProps> = (props) => {
  const { onClose, location, styles } = props

  const locationSearchTerm = useMemo(
    () => getLocationSearchTerm(location),
    [location],
  )

  const { onSave, billTo, setBillTo } = useActions(props)

  const {
    loading,
    items,
    page,
    pages,
    onChangePage,
    count,
    searchText,
    onChangeSearchText,
  } = useSearchBillTos(locationSearchTerm, 5)

  const multiplePages = pages > 1
  const theme = useTheme()
  return (
    <SideDrawerForm
      onSave={onSave}
      onCancel={onClose}
      containerStyle={styles.matchForm}
      containerBottom={multiplePages ? '116px' : '69px'}
      saveBtnDataTestId="billToMatchSaveBtn"
      footer={
        multiplePages && (
          <Box
            p={1}
            display="flex"
            sx={{
              position: 'absolute',
              bottom: '73px',
              borderTop: `1px solid ${theme.palette.divider}`,
              background: theme.palette.common.white,
            }}
            width="100%"
          >
            <Pagination page={page} pages={pages} onChangePage={onChangePage} />
          </Box>
        )
      }
    >
      <Header {...props} />
      <SearchSection
        styles={styles}
        count={count}
        searchText={searchText}
        onChangeSearchText={onChangeSearchText}
      />
      <BillToMatchList
        {...props}
        billTos={items}
        loading={loading}
        selectedBillTo={billTo}
        onSelectBillTo={setBillTo}
      />
    </SideDrawerForm>
  )
}
BillToMatchDrawer.displayName = 'BillToMatchDrawer'
